fragment CollectionInformationFragment on collectionInformation_Entry {
  typeHandle
  heading
  shortDescription
  longDescription
}
